<template>
  <div class="d-flex flex-y-center writer-box-content-step">
    <div class="pointer" style="padding: 0.3rem 0.3rem 0 0;" @click="goHome">
      <i class="" style="font-size: 1.5rem;"><img src="@/assets/icon-home.png" width="40" height="40" alt=""></i>
    </div>
    <div style="flex:1">
      <el-steps :active="active" finish-status="success" simple style="position: relative;">
        <el-step
          :class="{'pointer': ( index < story.stepNumber), 'current-steps': index == active, 'unclick': ( index >= story.stepNumber)}"
          v-for="(item, index) in steps"
          :key="index"
          :title="item.title"
          :description="item.description"
          :status="item.status"
          @click.native="stepClick(index)">
        </el-step>
        <div class="step-tips" v-if="steps[active].tips" :style="{left: `${active * 22.5}%`}">
          <img src="@/assets/icon-tips.png" height="14" style="display: inline-block; margin-right: 0.1rem;position: relative;top: 0.1rem;">
          {{ steps[active].tips }}
        </div>
      </el-steps>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations} from 'vuex'
export default {
  name: 'Steps4IdeaWriter',
  props: {
    active: {// 当前激活的步骤 wait / process / finish / error / success
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      steps: [
        { title: this.$i18n.locale === 'zh' ? '故事要素' : 'Story Elements', description: '', status: 'finish', route: '/workspace/genbyidea', tips: '' },
        { title: this.$i18n.locale === 'zh' ? '故事章纲' : 'Story Chapter', description: '', status: 'finish', route: '/workspace/genbyidea2', tips: '' },
        { title: this.$i18n.locale === 'zh' ? '故事正文' : 'Story Content', description: '', status: 'finish', route: '/workspace/genbyidea3', tips: '' },
        { title: this.$i18n.locale === 'zh' ? '全文预览' : 'Full Preview', description: '', status: 'finish', route: '/workspace/genbyidea4' }
        // 假设步骤 3 已完成，其他步骤未完成
      ]
    }
  },
  mounted() {
    this.steps.forEach((item, index) => {
      if(index < this.story.stepNumber){
        item.status = 'success'
        if(index == 2){
          item.status = this.story.stepStatus
        }
      }else{
        item.status = 'wait'
      }
    })
  },
  computed: {
  	...mapState(['user', 'story'])
  },
  created() {
  },
  methods: {
    ...mapMutations(['setActiveMenuItem','setStory']),
    stepClick(stepIndex) {
      console.log('stepNumber, stepIndex', this.story.stepNumber, stepIndex, this.steps[stepIndex]);
      // 如果步骤已完成，则更新 activeStep
      if (stepIndex < this.story.stepNumber) {
          this.$router.push(this.steps[stepIndex].route)
      }
      // this.$router.push(this.steps[stepIndex].route)
    },
    goHome(){
      this.$router.push('/workspace/mywork')
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-step.is-simple .el-step__head {
  align-items: center;
  display: flex;
}
/deep/ .el-step.is-simple .el-step__title{
  color: rgba(0,0,0,0.4);
}
/deep/ .el-step__title.is-success {
    color: rgba(0,0,0,0.9);
}
/deep/ .current-steps .el-step__main .el-step__title {
  font-weight: bold;
  color: #0052D9;
}
.current-steps {
  cursor: default;
}
.unclick {
  cursor: not-allowed;
}
.step-tips {
  font-size: 12px;
  line-height: 1rem;
  color: #242424;
  width: 8rem;
  padding: 0.5rem;
  background: #FFE8AB;
  border-radius: 0.5rem;
  position: absolute;
  top: -4rem;
  left: 0.5rem;
  z-index: 10;
  animation: popup 0.5s ease-out, shake 0.5s ease-in-out 0.5s 3, fadeOut 0.5s ease-in 9.5s forwards;
  &::after {
    content: '';
    position: absolute;
    bottom: -0.5rem;
    left: 45%;
    width: 0.5rem;
    height: 0.5rem;
    border-top: 0.5rem solid #FFE8AB;
    border-right: 0.5rem solid transparent;
    border-left: 0.5rem solid transparent;
  }
}

@keyframes popup {
  0% {
    opacity: 0;
    transform: translateY(20px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0) rotate(0deg);
  }
  25% {
    transform: translateX(-5px) rotate(-10deg);
  }
  75% {
    transform: translateX(5px) rotate(10deg);
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
}
</style>
